import React, { useState, useEffect, Fragment } from 'react';
import {
    Nav, TabContent, TabPane, NavItem,
    Card, CardBody, Input, ButtonGroup, Button, Row, Modal,
    ModalHeader,
    ModalBody,
    CustomInput
} from 'reactstrap';

import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import {
    Separator, Colxx
} from '../../../../../components/common/CustomBootstrap';
import { active } from 'sortablejs';

export default function BubblePosition({ botSettings, saveIntegration }) {

    /** other Digital Assistant state */
    const [edit, setEdit] = useState(false);
    const [editMobile, setEditMobile] = useState(false);
    const [settings, setSetting] = useState(botSettings.bubbleSettings.bubblePosition);
    const [hideBox, setHideBox] = useState(botSettings.hideSendBox);
    const [hideBoxMobile, setHideBoxMobile] = useState(botSettings.hideSendBoxInMobile);
    const [activeTab, setActiveTab] = useState('desktop');

    const handleChange = e => {
        const value = e.target.value;
        setSetting({
            ...settings,
            [e.target.name]: value,
        });
    };

    const handleSave = () => {
        botSettings.bubbleSettings.bubblePosition = settings
        botSettings.hideSendBox = hideBox;
        botSettings.hideSendBoxInMobile = hideBoxMobile;
        if (activeTab === "desktop") {
            setEdit(!edit);
        }
        else {
            setEditMobile(!editMobile);
        }
        saveIntegration({ botSetting: botSettings });
    };

    const handleCheckChange = e => {
        if (e.target.name === "hideBoxMobile") {
            setHideBoxMobile(e.target.checked);
        }
        else {
            setHideBox(e.target.checked);
        }
    };

    const toggleMenu = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    const Show = () => {
        return (
            <Fragment>
                {botSettings ? (
                    <Fragment>
                        <Card className="m-4 p-4">
                            <Colxx sm={12}>
                                <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                                    <b>Alignment</b>
                                    <span>{botSettings.bubbleSettings.bubblePosition.align}</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                                    <b>Alignment Margin</b>
                                    <span>{botSettings.bubbleSettings.bubblePosition.side}px</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                                    <b>Bottom Margin</b>
                                    <span>{botSettings.bubbleSettings.bubblePosition.bottom}px</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center py-2">
                                    <b>Hide Typing Textbox</b>
                                    <span>{botSettings.hideSendBox === true ? 'Yes' : 'No'}</span>
                                </div>
                            </Colxx>
                        </Card>
                        <Separator className='mb-3' />
                        <div className="text-center">
                            <Button
                                size="xs"
                                color="success"
                                outline
                                style={{ marginBottom: '15px' }}
                                onClick={() => {
                                    setEdit(!edit);
                                }}
                            >
                                Edit
                            </Button>
                        </div>
                    </Fragment>
                ) : null}
            </Fragment>
        );
    };

    function Edit() {
        return (
            <Fragment>
                {botSettings ? (
                    <Fragment>
                        <Card className="m-4 p-4">
                            <Colxx sm={12}>
                                <div className="mb-3">
                                    <b className="d-block mb-1">Alignment</b>
                                    <Input
                                        name="align"
                                        type="select"
                                        defaultValue={botSettings.bubbleSettings.bubblePosition.align}
                                        onChange={handleChange}
                                    >
                                        <option value="Left">Left</option>
                                        <option value="Right">Right</option>
                                    </Input>
                                </div>
                                <div className="mb-3">
                                    <b className="d-block mb-1">Alignment Margin (px)</b>
                                    <Input
                                        name="side"
                                        type="number"
                                        defaultValue={botSettings.bubbleSettings.bubblePosition.side}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="mb-3">
                                    <b className="d-block mb-1">Bottom Margin (px)</b>
                                    <Input
                                        name="bottom"
                                        type="number"
                                        defaultValue={botSettings.bubbleSettings.bubblePosition.bottom}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="mb-1 d-flex align-items-center">
                                    <CustomInput
                                        type="checkbox"
                                        id="chkTerms"
                                        checked={hideBox}
                                        onChange={handleCheckChange}
                                        name="hideBox"
                                    />
                                    <b className="ms-2">Hide Typing Textbox</b>
                                </div>
                            </Colxx>
                        </Card>
                        <Separator className='mb-3 ' />
                        <div className="mb-3 text-center">
                            <Button color="primary" size="xs" onClick={handleSave}>
                                Save
                            </Button>
                            <Button size="xs" color="secondary" className='ml-2' onClick={() => { setEdit(!edit) }}>
                                Cancel
                            </Button>
                        </div>
                    </Fragment>
                ) : null
                }
            </Fragment >
        );
    }

    const ShowMobile = () => {
        return (
            <Fragment>
                {botSettings ? (
                    <Fragment>
                        <Card className="m-4 p-4">
                            <Colxx sm={12}>
                                <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                                    <b>Alignment</b>
                                    <span>{botSettings.bubbleSettings.bubblePosition.alignInMobile}</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                                    <b>Alignment Margin</b>
                                    <span>{botSettings.bubbleSettings.bubblePosition.sideInMobile}px</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                                    <b>Bottom Margin</b>
                                    <span>{botSettings.bubbleSettings.bubblePosition.bottomInMobile}px</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center py-2">
                                    <b>Hide Typing Textbox</b>
                                    <span>{botSettings.hideSendBoxInMobile === true ? 'Yes' : 'No'}</span>
                                </div>
                            </Colxx>
                        </Card>
                        <Separator className='mb-3' />
                        <div className="text-center">
                            <Button
                                size="xs"
                                color="success"
                                outline
                                style={{ marginBottom: '15px' }}
                                onClick={() => {
                                    setEditMobile(!editMobile);
                                }}
                            >
                                Edit
                            </Button>
                        </div>
                    </Fragment>
                ) : null}
            </Fragment>
        );
    };

    function EditMobile() {
        return (
            <Fragment>
                {botSettings ? (
                    <Fragment>
                        <Card className="m-4 p-4">
                            <Colxx sm={12}>
                                <div className="mb-3">
                                    <b className="d-block mb-1">Alignment</b>
                                    <Input
                                        name="alignInMobile"
                                        type="select"
                                        defaultValue={botSettings.bubbleSettings.bubblePosition.alignInMobile}
                                        onChange={handleChange}
                                    >
                                        <option value="Left">Left</option>
                                        <option value="Right">Right</option>
                                    </Input>
                                </div>
                                <div className="mb-3">
                                    <b className="d-block mb-1">Alignment Margin (px)</b>
                                    <Input
                                        name="sideInMobile"
                                        type="number"
                                        defaultValue={botSettings.bubbleSettings.bubblePosition.sideInMobile}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="mb-3">
                                    <b className="d-block mb-1">Bottom Margin (px)</b>
                                    <Input
                                        name="bottomInMobile"
                                        type="number"
                                        defaultValue={botSettings.bubbleSettings.bubblePosition.bottomInMobile}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="mb-1 d-flex align-items-center">
                                    <CustomInput
                                        type="checkbox"
                                        id="chkTerms1"
                                        checked={hideBoxMobile}
                                        onChange={handleCheckChange}
                                        name="hideBoxMobile"
                                    />
                                    <b className="ms-2">Hide Typing Textbox</b>
                                </div>
                            </Colxx>
                        </Card>
                        <Separator className='mb-3 ' />
                        <div className="mb-3 text-center">
                            <Button color="primary" size="xs" onClick={handleSave}>
                                Save
                            </Button>
                            <Button size="xs" color="secondary" className='ml-2' onClick={() => { setEditMobile(!editMobile); }}                            >
                                Cancel
                            </Button>
                        </div>
                    </Fragment>
                ) : null
                }

            </Fragment >
        );
    }
    return (
        <Card className="mb-4">
            <CardBody>
                <div className="text-center">
                    <h6>Position</h6>
                </div>
                <Separator className="mb-3" />
                <Card className="m-4 ">
                    <Nav tabs className="separator-tabs ml-0 mr-0">
                        <NavItem className="w-50 text-center">
                            <NavLink
                                style={{ marginTop: "10px" }}
                                to="#"
                                location={{}}
                                className={classnames({
                                    active: activeTab === 'desktop',
                                    'nav-link': true,
                                })}
                                onClick={() => toggleMenu('desktop')}
                            >
                                Desktop
                            </NavLink>
                        </NavItem>
                        <NavItem className="w-50 text-center">
                            <NavLink
                                style={{ marginTop: "10px" }}
                                to="#"
                                location={{}}
                                className={classnames({
                                    active: activeTab === 'mobile',
                                    'nav-link': true,
                                })}
                                onClick={() => setActiveTab('mobile')}
                            >
                                Mobile
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="desktop">
                            <>{edit ? Edit() : Show()}</>
                        </TabPane>
                    </TabContent>
                    <TabContent activeTab={activeTab} >
                        <TabPane tabId="mobile">
                            <>{editMobile ? EditMobile() : ShowMobile()}</>
                        </TabPane>
                    </TabContent>
                </Card>
            </CardBody>
        </Card>);
}
